import { number, object, string } from "yup"
import { buildSchema } from "./util/build-schema"

const schema = object({
  buyingPower: number().required("Adjustment value is required"),
  note: string().required("Note is required"),
})

export const buyingPowerSchema = buildSchema("buyingPowerParams", schema)
